import { render } from "./VcnContent.vue?vue&type=template&id=3b945ba8&scoped=true"
import script from "./VcnContent.vue?vue&type=script&lang=js"
export * from "./VcnContent.vue?vue&type=script&lang=js"

import "./VcnContent.vue?vue&type=style&index=0&id=3b945ba8&scoped=true&lang=css"
import "./VcnContent.vue?vue&type=style&index=1&id=3b945ba8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b945ba8"]])

export default __exports__